/* eslint-disable tss-unused-classes/unused-classes */
import { makeStyles } from 'tss-react/mui';
import { CustomFilter } from 'app/ComponentLibrary/Filter';
import React, { useState, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { defaultPlacementHistoryFilters, getPlacementHistoryFilters } from './PlacementHistoryFilterUtils';
import { gridStateActions } from '@AMIEWEB/Common/Grid/GridStateManagement/GridState.redux';
import { selectGridFiltersExpanded } from '@AMIEWEB/Common/Grid/GridStateManagement/GridState.selectors';
import { SearchPageIcons } from 'app/ComponentLibrary/Filter/SearchPageIcons';
import { Grid } from '@mui/material';
import { selectPlacementProgress } from 'store/redux-store/placement-details/selectors';
import { placementStatusOptions } from '@AMIEWEB/Placement/NextPlacementStatus/StatusDefaults';

const useStyles = makeStyles()({
  fillterCollapse: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '3px',
  },
});

export const PlacementHistoryFilters = props => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const [fields, setFields] = useState(null);
  const { reset } = useFormContext();
  const filtersExpanded = useSelector(selectGridFiltersExpanded);
  const { activityStatusId } = useSelector(selectPlacementProgress);
  const dispatch = useDispatch();

  const fetchPricingDeskFilterSpecs = () => {
    setFields(
      getPlacementHistoryFilters(t, activityStatusId < placementStatusOptions.bookingApproved.activityStatusId),
    );
  };

  const resetFilter = () => {
    reset(defaultPlacementHistoryFilters);
    dispatch(
      gridStateActions.setFilterAttributes({
        filterObject: Object.entries(defaultPlacementHistoryFilters),
      }),
    );
    props.setResetGridParams(true);
  };

  useEffect(() => {
    fetchPricingDeskFilterSpecs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activityStatusId]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={11}>
        <CustomFilter
          fields={fields}
          justifyContent={'flex-start'}
          version2
          resetBtn
          analytics={{
            caller: 'Account Management WorkDesk Filter',
            onApply: true,
            properties: {
              category: 'Placements',
            },
          }}
        />
      </Grid>
      <Grid item xs={1} className={classes.fillterCollapse}>
        <SearchPageIcons resetlbutton checked={filtersExpanded} onResetForm={() => resetFilter()} />
      </Grid>
    </Grid>
  );
};
